import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledNav = styled.nav`
  background: ${(props) =>
    props.$isGradient
      ? `linear-gradient(45deg, ${props.$bgColorStart}, ${props.$bgColorMid}, ${props.$bgColorEnd})`
      : props.$bgColor};
  padding-top: ${(props) => props.$paddingTop}rem;
  padding-bottom: ${(props) => props.$paddingBottom}rem;
  h1 {
    color: ${(props) => props.$h1Color};
    font-size: ${(props) => props.$h1Size} !important;
  }
  h2 {
    color: ${(props) => props.$h2Color} !important;
  }
  h3 {
    color: ${(props) => props.$h3Color} !important;
  }
`;

const Nav = (props) => {
  const {
    padding,
    children,
    classes,
    idName,
    bgColor,
    bgColorStart,
    bgColorMid,
    bgColorEnd,
    isGradient,
    paddingTop,
    paddingBottom,
    h1Color,
    h1Size,
    h2Color,
    h3Color,
  } = props;
  const paddingMap = {
    lg: 6,
    md: 4,
    sm: 2,
    top: 6,
    bottom: 6,
    none: 0,
    custom: [paddingTop, paddingBottom],
    default: 6,
  };

  const paddingTopValue = Array.isArray(paddingMap[padding])
    ? paddingMap[padding][0]
    : paddingMap[padding];
  const paddingBottomValue = Array.isArray(paddingMap[padding])
    ? paddingMap[padding][1]
    : paddingMap[padding];

  return (
    <StyledNav
      $bgColor={bgColor}
      $bgColorStart={bgColorStart}
      $bgColorMid={bgColorMid}
      $bgColorEnd={bgColorEnd}
      $isGradient={isGradient}
      $h1Size={h1Size}
      $h1Color={h1Color}
      $h2Color={h2Color}
      $h3Color={h3Color}
      $paddingTop={paddingTopValue}
      $paddingBottom={paddingBottomValue}
      className={`relative ${classes}`}
      id={idName}
    >
      {children}
    </StyledNav>
  );
};

Nav.defaultProps = {
  padding: 'lg',
  classes: '',
  isGradient: false,
};

Nav.propTypes = {
  padding: PropTypes.string,
  classes: PropTypes.string,
  children: PropTypes.node.isRequired,
  bgColor: PropTypes.string,
  bgColorStart: PropTypes.string,
  bgColorMid: PropTypes.string,
  bgColorEnd: PropTypes.string,
  isGradient: PropTypes.bool,
};

export { Nav };
